import React from 'react';
import { SidebarItem } from '../screens';
import { useParams } from 'react-router-dom';
import { useUser } from '../hooks';
import UserAccess from '../UserAccess';

interface EmploymentSidebarProps{
	
}

var EmploymentSidebar = (props: EmploymentSidebarProps)=>{
	var params = useParams<{ id: string }>();
	var { hasAccess } = useUser();
	
	return <>
		<SidebarItem iconName='arrow-left' text='Regresar' to={'/employments'} />
		<div className='divider'>Empleo</div>
		{hasAccess(UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS) && (
			<SidebarItem iconName='calendar-alt' text='Horarios' to={`/employments/${params.id}/schedules`} />
		)}
		{hasAccess(UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS) && (
			<SidebarItem iconName='users' text='Empleados' to={`/employments/${params.id}/workers`} />
		)}
	</>
}

export default EmploymentSidebar;
